module.exports = __webpack_public_path__ + "static/media/timeout.38f5724.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/timeout.wav
// module id = TOXh
// module chunks = 1